import React from 'react'
import '../Styles/ModalStyles.css'
import { Button, Modal, Select, Tooltip } from 'antd'
import { CloseOutlined, FormOutlined } from "@ant-design/icons";
import { Option } from 'antd/es/mentions';


const AuditFilterModal = ({
  visible,
  handleCancel,
  handleApply,
  resetFields,

  l1Filters,
  selectedL1Filter,
  setselectedL1Filter,
  l2Filters,
  selectedL2Filter,
  setselectedL2Filter,
  l3Filters,
  selectedL3Filter,
  setselectedL3Filter,

  l1name,
  l2name,
  l3name,


}) => {
  

  const handleL1Select = async (value) => {
    setselectedL1Filter(value)
    // await fetchL2Filters()
  }

  const handleL2Select = async (value) => {
    //console.log(value)
    setselectedL2Filter(value)
    // await fetchL3Filters()
    
  }

  const handleL3Select = async (value) => {
    //console.log(value)
    setselectedL3Filter(value)
  }


  return (
    <Modal title={<p className="modal-heading">FILTER AUDITS</p>}
      onOk={handleApply}
      open={visible}
      footer={null}
      onCancel={handleCancel}
      width={600}
    >
      <div>
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "1rem",
              width : "60rem"
            }}
          >
            <Tooltip title={l1name}>
            <p className="my-form-lables" style={{width : "20rem"}}>{l1name ? l1name : "Loading" } : </p>
            </Tooltip>
            <Select
              showSearch
              placeholder="Select L1"
              className="my-form-input"
              style={{
                width : "30rem",
                marginLeft: "1rem",
                borderRadius: "0.7rem",
                borderColor: "#818589",
              }}
              onSelect={handleL1Select}
              // onBlur={getLevel2}
              value={selectedL1Filter}

            // mode="multiple"
            >
              {l1Filters?.map((l1) => (
                <Option key={l1.id} value={l1.id}>
                  {`${l1.entity_name}`}
                </Option>
              ))}
            </Select>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "1rem",
              width : "60rem"
            }}
          >
            <Tooltip title={l2name}>
            <p className="my-form-lables" style={{width : "20rem"}}>{l2name ? l2name : "Loading" }: </p>
            </Tooltip>
            <Select
              showSearch
              placeholder="Select L2"
              className="my-form-input"
              style={{
                width : "30rem",
                marginLeft: "1rem",
                borderRadius: "0.7rem",
                borderColor: "#818589",
              }}
              onSelect={handleL2Select}
              // onBlur={getLevel3}
              value={selectedL2Filter}

            // mode="multiple"
            >
              {l2Filters?.map((l2) => (
                <Option key={l2.id} value={l2.id}>
                  {`${l2.division_name}`}
                </Option>
              ))}
            </Select>
          </div>

          <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "1rem",
            width : "60rem"
          }}
          >
            <Tooltip title={l3name}>
            <p className="my-form-lables" style={{width : "20rem"}}>{l3name ? l3name : "Loading" }: </p>
            </Tooltip>
            <Select
              showSearch
              placeholder="Select L3"
              className="my-form-input"
              style={{
                width : "30rem",
                marginLeft: "1rem",
                borderRadius: "0.7rem",
                borderColor: "#818589",
              }}
              onSelect={handleL3Select}
              value={selectedL3Filter}
            >
              {l3Filters?.map((l3) => (
                <Option key={l3.id} value={l3.id}>
                  {`${l3.department_name}`}
                </Option>
              ))}
            </Select>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          height: "2rem",
          marginTop: "1rem",
          marginBottom: "1rem",
        }}
      >
        <Button key="back" onClick={handleCancel}>
          <CloseOutlined />
          Cancel
        </Button>
        <Button
          type="primary"
            onClick={resetFields}
          style={{ marginLeft: "1rem" }}
        >
          {/* <CloseOutlined /> */}
          Reset
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          style={{
            background: "#f58029",
            fontWeight: "600",
            marginLeft: "1rem",
          }}
          onClick={handleApply}
          className="save-update-btn"
        >
          Apply
          <FormOutlined />
        </Button>
      </div>
    </Modal>
  )
}

export default AuditFilterModal